import {Job} from './Job';

export enum ContactUsType {
    Job = 'Job'
}
export interface ContactUsJobParams {
    type: ContactUsType.Job,
    data: Job
}
export type ContactUsParams = ContactUsJobParams;



// WEBPACK FOOTER //
// ./src/types/ContactUs.ts